import { SelectionPromotion } from '@teko/cart/v2';
import { DiscoveryProduct } from '@teko/discovery';
import { hasComboDiscount } from '@teko/teko-ecommerce';
import { AddToCartPayload, ProductPrice } from '../hooks';
import { useComboPopupStore } from '../stores/comboPopupStore';
import { ConvertedProduct } from '../types';

interface OpenComboPopupFromDetailArgs {
  product?: ConvertedProduct;
  primitiveProduct?: DiscoveryProduct;
  price?: ProductPrice;
  payloadAddToCart?: AddToCartPayload;
  selectedPromotion?: SelectionPromotion | null;
}

/**
 * Opens the SGC add-to-cart combo popup for the product-detail page when the
 * viewed product has a combo. Passes the stepper quantity so "Mua sản phẩm
 * đang xem" adds that many, while "Mua combo" adds the combo's own quantities.
 *
 * @returns true if the popup was opened (caller must then stop its own add-to-cart).
 */
export const tryOpenComboPopupFromDetail = ({
  product,
  primitiveProduct,
  price,
  payloadAddToCart,
  selectedPromotion,
}: OpenComboPopupFromDetailArgs): boolean => {
  if (!product) return false;
  if (!hasComboDiscount(primitiveProduct?.prices?.[0]?.bestComboDiscount))
    return false;

  const { enabled, open } = useComboPopupStore.getState();
  if (!enabled) return false;

  open({
    sku: payloadAddToCart?.sku ?? product.sku,
    sellerSku: product.sellerSku,
    name: product.name,
    imageUrl: product.images?.[0]?.src ?? '',
    uom: product.uomName,
    price: {
      latestPrice: price?.finalPrice || 0,
      supplierRetailPrice: product.price?.supplierRetailPrice
        ? Number(product.price.supplierRetailPrice)
        : undefined,
    },
    selectPromotionId:
      selectedPromotion?.promotionId ?? product.selectPromotionId,
    brand: product.brand,
    quantity: payloadAddToCart?.quantity,
  });
  return true;
};
